package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable

@Serializable
data class TableColumn(
    val name: String,
    val ruTitle: String = "",
    var index: Int? = null,
    val type: ColumnType = ColumnType.String
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is TableColumn) return false

        // Compares properties for structural equality
        return this.name == other.name && this.index == other.index && this.type == other.type
    }

    override fun hashCode(): Int {
        return this::class.hashCode()
    }
}

@Serializable
enum class ColumnType (val sqlName: kotlin.String ) {
    String( "String"),
    Int("Int32"),
    UInt16("UInt16"),
    Long("Int64"),
    Float( "Float32"),
    Double( "Float64"),
    Date( "Date"),
    DateTime( "DateTime"),
    Bool( "Bool"),
    UUID( "UUID"),
    Byte( "Int8"),
    IPv4("IPv4"),
    String_Array("Array(String)")
}

@Serializable
data class WhereCondition(
    val columnName: String,
//    val operator: Operator? = null,
    val columnType: ColumnType,
    val values: List<String>
)

@Serializable
data class Pagination(
    val limit: Int?,
    val offset: Int?
)

@Serializable
object Operator{
    const val equal = "="
    const val notEqual = "!="
    const val gte = ">="
    const val lte = "<="
    const val gt = ">"
    const val lt = "<"
}